var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.95 4.293v8.237c0 .307-.224.556-.5.556s-.5-.249-.5-.556V4.293L3.854 8.389a.5.5 0 1 1-.708-.707L7.39 3.439a1.5 1.5 0 0 1 2.121 0l4.243 4.243a.5.5 0 1 1-.707.707z"
  })));
};
export default SvgArrowUp;